define('common/ko/fn/subscribeToChanges',['knockout'], function(ko) {
    ko.subscribable.fn.subscribeToChanges = function (callback) {
        var oldValue;
        this.subscribe(function (_oldValue) {
            oldValue = _oldValue;
        }, this, 'beforeChange');

        this.subscribe(function (newValue) {
            callback(newValue, oldValue);
        });
    };
});
